module.exports = __webpack_public_path__ + "static/assets/df728c8ed0d77f8b0623925fc33be017.svg";